<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="col-sm-9"><span>Bike Rack</span></div>
        <div *ngIf="parent.suiteData && parent.directoryService.account.canUpdate('bldn', parent.suiteData.building.id)" class="col-sm-3">
            <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="create()">
                <i class="fa fa-plus-circle"></i> Add Bike Rack
            </button>
        </div>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form *ngIf="data"
                  #form="ngForm"
                  (ngSubmit)="update(form)"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <input-field [ngModel]="data.rackNumber"
                             name="rackNumber"
                             [required]="true"
                             [title]="'Rack #'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({rackNumber: form.value.rackNumber});
                                       updateNameInList('bikeRacksList', data.id, 'rackNumber',form.value.rackNumber)">
                </input-field>

                <boolean-field name="rentedOut"
                               [title]="'Rented Out'"
                               [(ngModel)]="data.rentedOut"
                               [noEdit]="!data.isCanEdit"
                               (update)="update({rentedOut: form.value.rentedOut}); resetRentedTo()">
                </boolean-field>

                <!--** building ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToBuilding', true)">
                    <div class="dv-label col-sm-3 strong">Building</div>
                    <div class="dv-value col-sm-9" *ngIf="!data.formFields.rentedToBuilding.editMode">
                        <span>{{data.extendedRentedTo.buildingName || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToBuilding', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>
                    <div class="dv-value-edit col-sm-9" *ngIf="data.formFields.rentedToBuilding.editMode">
                        <select class="form-control"
                                name="building"
                                [ngModel]="data.extendedRentedTo.building"
                                (change)="changeBuilding($event.target.value)"
                                required>
                            <option value="" hidden></option>
                            <option *ngFor="let build of directoryService.buildings"
                                    [value]="build.id">{{build.name}}
                            </option>
                        </select>
                        <button type="button" (click)="applyChanges(form)">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(data, 'rentedToBuilding', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <!--** rentedToSuite ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToSuite', true)">
                    <div class="dv-label col-sm-3">
                        <label>Unit</label>
                    </div>
                    <div class="dv-value col-sm-9" *ngIf="!data.formFields.rentedToSuite.editMode">
                        <span>{{data.extendedRentedTo.suiteNumber || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToSuite', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>
                    <div class="dv-value-edit col-sm-9" *ngIf="data.formFields.rentedToSuite.editMode">
                        <search-select [ngModel]="data.extendedRentedTo.suite"
                                       name="suite"
                                       required
                                       style="height: 26px;"
                                       (ngModelChange)="changeUnit($event, form)"
                                       [data]="suiteToSearchSelect(suites)">
                        </search-select>
                        <input *ngIf="form.value.suite === 0"
                               class="form-control"
                               [ngModel]="data.extendedRentedTo.suiteNumber"
                               name="suiteNumber"
                               placeholder="Other Unit Number"
                               maxlength="255" required>
                        <spinner [spinnerShow]="form.value.building && !suites.length"></spinner>
                        <button type="button" (click)="applyChanges(form)">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(data, 'rentedToSuite', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <!--** rentedToSuiteUser ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToSuiteUser', true)">
                    <div class="dv-label col-sm-3">
                        <label>Resident</label>
                    </div>
                    <div class="dv-value col-sm-9" *ngIf="!data.formFields.rentedToSuiteUser.editMode">
                        <span>{{data.extendedRentedTo.suiteUserName || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToSuiteUser', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>

                    <div class="dv-value-edit col-sm-9" *ngIf="data.formFields.rentedToSuiteUser.editMode">
                        <select class="form-control"
                                (change)="changeResident($event.target.value)"
                                [ngModel]="data.extendedRentedTo.suiteUser"
                                name="suiteUser"
                                required
                                #residentSelect
                                [disabled]="!residents.length">
                            <option value="" hidden></option>
                            <option *ngFor="let resident of residents" [value]="resident.id">
                                {{resident.fullName}}
                            </option>
                        </select>
                        <input *ngIf="residentSelect.value === '0'"
                               class="form-control"
                               placeholder="Other Resident Name"
                               [ngModel]="data.extendedRentedTo.suiteUserName"
                               name="suiteUserName"
                               maxlength="255" required>
                        <spinner [spinnerShow]="form.value.suite && !residents.length"></spinner>
                        <button type="button" (click)="applyChanges(form)">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(data, 'rentedToSuiteUser', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <textarea-field name="note"
                                [title]="'Notes'"
                                [noEdit]="!data.isCanEdit"
                                [ngModel]="data.note"
                                [maxLength]="255"
                                (update)="update({note: form.value.note})">
                </textarea-field>

                <div class="btn-group" *ngIf="data.id && data.isCanDelete">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a (click)="remove()">Delete</a></li>
                    </ul>
                </div>

            </form>
        </div>
    </div>
    <spinner [spinnerShow]="parent.spinnerShow"></spinner>
</div>

<div class="boxForModal" *ngIf="isCreateModal && parent.suiteData">
    <bike-rack-create [closeTrigger]="hideModal"
                      (onPopupClose)="hideModal()"
                      [buildingId]="parent.suiteData.building.id"
                      [suiteId]="parent.suiteData.id"
                      [inDirectoryItemView]="true">
    </bike-rack-create>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/bike-racks/bike-racks.template.html